import {createAsyncThunk} from '@reduxjs/toolkit';
import axios from "axios";
import logoutAndRedirect from "../../utils/logoutAndRedirect";
import { getAccessToken } from "../../utils/tokenStore";

const URL_API = process.env.URL_API;

export interface ResetResult {
    data: any[];
}

export const updateQuote = createAsyncThunk(
    'quote/update',
    async (post_data: any, { rejectWithValue }) => {

        const updateQuoteURL = `${URL_API}/supplier-portal/quote-request-forms/${post_data.quoteID}/quotes/${post_data.quoteRequestID}`;

        try {
            const { data } = await axios.put<ResetResult>(updateQuoteURL, post_data.request, {
                headers: {
                    'Authorization': `Bearer ${getAccessToken()}`
                }
            });

            return data;

        } catch (error) {

            // @ts-ignore
            if(error.response.status === 401){
                logoutAndRedirect('/sign-in')
            }

            // @ts-ignore
            return rejectWithValue(error.response.data)
        }
    }
);